import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
// import AccessibilityWidget from "@/components/AccessibilityWidget";
import { Navbar } from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

export function Layout() {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";
  const isUserFormPage = location.pathname === "/user-form";

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1 pt-16">
        <Outlet />
      </main>
      {!isUserFormPage && (
        <Footer variant={isLandingPage ? "background" : "secondary"} />
      )}
      {/* <AccessibilityWidget /> */}
      <Toaster richColors />
    </div>
  );
}